// Generated by ReScript, PLEASE EDIT WITH CARE

import * as VehicleStateMapper from "../entity-mapper/VehicleStateMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";

var execute = VehicleStateMapper.builder;

var VehicleTypesRepoConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var VehicleTypesResponseConverter = partial_arg(VehicleTypesRepoConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  VehicleTypesRepoConfig ,
  VehicleTypesResponseConverter ,
  
}
/* VehicleTypesResponseConverter Not a pure module */
